import { render, staticRenderFns } from "./NewCurrent.vue?vue&type=template&id=b7a75be4"
import script from "./NewCurrent.vue?vue&type=script&lang=js"
export * from "./NewCurrent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports